module.exports = __webpack_public_path__ + "media/assets/images/flags/ag-98e022393b78fa356c0cb47ad24b9316.svg";